'use strict';

/**
 * Rudimentary handler of feature flags for groups of users
 *
 * @abstract
 */
export abstract class FeatureFlag {
  static usersCommissionStatements: Array<number> = [
    1519,
    2464, // Users electing to test new commission statements feature
    4169,
    1, // Test accounts
    6217, // Rami Mustafa
    23, // Jason Byram
    5624, // Rocco Sileo
    670, // Rob Rockey
    6482, // Lisa Hemby
    10996 // Amanda Bow
  ];

  static connectureEnroll: Array<number> = [
    395,
    4169,
    1,
    145,
    5895, // Test accounts & Alan Zins (395), Seth Clayton (145)
  ];

  static userFlows: Array<number> = [
    4169, // local
    1, // andrew prod
    3459, // Ron Hnderson
    7194, // Nick Knightly
    670, // Rob Rockey
    5172, // ryan
    4298, // Renee
    7332, // Todd Poe
    3712, // Nancy Lawrence
  ];

  /**
   * Check to see if a particular User ID can access this feature.
   *
   * @param userId Id of the user we're checking can access this feature
   * @returns {boolean} Returns true if the user can access this feature.
   */
  static canAccessCommissionStatements(userId: number): boolean {
    return this.usersCommissionStatements.includes(userId);
  }

  /**
   * Check to see if a particular User ID can access this feature.
   *
   * @param userId Id of the user we're checking can access this feature
   * @returns {boolean} Returns true if the user can access this feature.
   */
  static canAccessFlows(userId: number): boolean {
    return this.userFlows.includes(userId);
  }

  /**
   * Check to see if a particular User ID can access this feature.
   *
   * @param userId Id of the user we're checking can access this feature
   * @returns {boolean} Returns true if the user can access this feature.
   */
  static canAccessConnectureEnroll(userId: number): boolean {
    return this.connectureEnroll.includes(userId);
  }
}
